import { route } from '../mixins/route';
import { ConfigMixin } from '../mixins/config';
import { TimeHelper } from '../mixins/time';
import { helper } from '../mixins/helper';

export const LandingAPI = {
  mixins: [route, ConfigMixin, TimeHelper, helper],
  methods: {
    getListGameByOrderAPI() {
      return this.$http.get(this.routeGetListGameByOrder());
    },
    getListBannerAPI() {
      return this.$http.get(this.routeLandingGetListBanner());
    },
    getListBannerMobileAPI() {
      return this.$http.get(this.routeLandingGetListBannerMobile());
    },
    async getListEventsAPI(category, limit = 0, seeAll = 0) {
      const timezone = encodeURIComponent(this.guessTimezone());
      const url = this.routeFilterEventV2() + '&category=' + category +
          '&limit=' + limit ? limit : this.LIMIT_DEFAULT_SLICK_EVENT + '&see_all=' + seeAll + '&timezone=' + timezone;
      const res = await this.$http.get(url);
      return this.changeDataEventTimezone(res.data);
    },
    async getListTrendingHubAPI() {
      try {
        const res = await this.$http.get(this.routeGetTrendingHubs());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    async getListRecentNewsAPI() {
      try {
        const res = await this.$http.get(this.routeGetRecentNews());
        return res.data.content;
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    async getListTrendingVideoAPI(page = 1, limit = 10) {
      try {
        const res = await this.$http.get(this.routeTwitchClips() + '?filterBy=10&sortBy=views&json=1&limit=' + limit + '&page=' + page);
        return res.data.content;
      } catch (error) {
        console.log(error);
      }
      return [];
    },
    async getFAQStatusesAPI() {
      try {
        const res = await this.$http.get(this.routeGetFAQStatuses());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return {};
    },
    async getBoomAlertsAPI() {
      try {
        const res = await this.$http.get(this.routeGetBoomAlerts());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return {};
    },
    async checkUserUpdateEmailAPI() {
      try {
        const res = await this.$http.get(this.routeAPICheckUserUpdateEmail());
        return res.data.data;
      } catch (error) {
        console.log(error);
      }
      return {};
    },
    async clearImportUserSessionAPI() {
      try {
        await this.$http.get(this.routeAPIClearImportUserSession());
      } catch (error) {
        console.log(error);
      }
    },
  },
};
